import moment from 'moment';

class DateTool {
    constructor() {
        this.fullFormat = 'DD/MM/YYYY';
        this.shortFormat = 'DD/MM';
        this.shortFormat2 = 'DD/MM/YY';
        this.ISO_DATE_FORMAT = 'YYYY-MM-DD';
    }

    format(date, type) {
        type = typeof type !== 'undefined' ? type : 'full';
        if (type === 'short') {
            return date.format(this.shortFormat);
        }
        if (type === 'short2') {
            return date.format(this.shortFormat2);
        }
        return date.format(this.fullFormat);
    }

    createDate (string) {
        return moment(string, this.ISO_DATE_FORMAT).hours(0).minutes(0).seconds(0).milliseconds(0);
    };
}

export default new DateTool;
